const warningModalEquipService = {
  titleInactivate: 'Inactivate Service',
  textInactivate: 'By disabling this service, it will no longer be used for this type of equipment, will not count towards the status calculation, and will lose its scheduled services, but its history will be preserved.',
  text2Inactivate: 'Do you wish to proceed?',
  confirmButtonTextInactivate: 'INACTIVATE SERVICE',
  titleActivate: 'Activate Service',
  textActivate: 'By activating this service, it will be used for this type of equipment, will count towards the status calculation.',
  text2Activate: 'Do you wish to proceed?',
  confirmButtonTextActivate: 'ACTIVATE SERVICE',
};

export default warningModalEquipService;
